import { gql } from "@apollo/client";

const ADMIN_USER_FIELDS = `
  externalId
  email
  firstName
  lastName
  avatarUrl
  isEnabled
  lastSignInAt
  permissions
`;

/** Paginated list of users with admin access, backing the Settings > Users table. */
export const GET_ADMIN_USERS = gql`
  query GetAdminUsers(
    $search: String
    $includeDisabled: Boolean = false
    $pageNumber: Int = 0
    $pageSize: Int = 25
  ) {
    adminUsers(
      search: $search
      includeDisabled: $includeDisabled
      pageNumber: $pageNumber
      pageSize: $pageSize
    ) {
      count
      pageNumber
      pageSize
      items {
        ${ADMIN_USER_FIELDS}
      }
    }
  }
`;

/** A single admin user with their current grants, loaded when the dialog opens in edit mode. */
export const GET_ADMIN_USER = gql`
  query GetAdminUser($externalId: String!) {
    adminUser(externalId: $externalId) {
      ${ADMIN_USER_FIELDS}
    }
  }
`;

/**
 * Email autocomplete for granting access to someone who is not an admin yet.
 * Returns any platform user, flagging the ones that already have admin access.
 */
export const SEARCH_USERS_BY_EMAIL = gql`
  query SearchUsersByEmail($email: String!, $limit: Int = 10) {
    searchUsersByEmail(email: $email, limit: $limit) {
      externalId
      email
      firstName
      lastName
      isAdmin
    }
  }
`;
